import axios from "axios";

export const AxiosMulti = (apiList = []) => {
  return axios.all(apiList);
};
